import { NodeViewProps } from '@tiptap/react'
import { VFC } from 'react'
import { Card } from './Card'
import { Inline } from './Inline'

/**
 * Wrapper Node View for EmbeddedResource extension.
 * Switches between different Components based on the `embedType` attribute.
 */
export const NodeView: VFC<NodeViewProps> = (props) => {
  const { embedType } = props.node.attrs

  switch (embedType) {
    case 'inline': {
      return <Inline {...props} />
    }
    case 'card': {
      return <Card {...props} />
    }
    default: {
      console.error('Invalid `embedType` found for embeddedResource Node.')
    }
  }

  return null
}
